import {useCallback} from 'react'
import {useSelector} from 'react-redux'
import {getLocalTaxesIncluded, getTaxesIncluded} from 'modules/meta/selectors'
import {getLengthOfStay, getShowTotalPrices} from 'modules/sapiSearch/selectors'
import {getSearchBoxValues} from 'modules/searchBox/selectors'

import {numberOfRooms} from '@vio/core/src/room/business/roomConfiguration'

import {PRICE_FILTER_MESSAGES} from './constants'

export const usePriceFilter = () => {
  const showTotalPrices = useSelector(getShowTotalPrices)
  const {rooms, optimizeRooms} = useSelector(getSearchBoxValues)
  const includeTaxes = useSelector(getTaxesIncluded)
  const includeLocalTaxes = useSelector(getLocalTaxesIncluded)
  const lengthOfStay = useSelector(getLengthOfStay)

  const hasMultipleRooms =
    Boolean(optimizeRooms) || numberOfRooms(rooms ?? '') > 1

  const getSubtitleMessage = () => {
    if (showTotalPrices) {
      if (hasMultipleRooms) return PRICE_FILTER_MESSAGES.totalMultipleRooms
      return PRICE_FILTER_MESSAGES.totalSingleRoom
    } else {
      if (includeTaxes && includeLocalTaxes) {
        if (hasMultipleRooms) {
          return PRICE_FILTER_MESSAGES.nightlyMultipleRoomsWithTaxAndFees
        }
        return PRICE_FILTER_MESSAGES.includingTaxesLong
      }
      if (!includeTaxes && !includeLocalTaxes) {
        if (hasMultipleRooms) {
          return PRICE_FILTER_MESSAGES.nightlyMultipleRoomsExclTaxAndFees
        }
        return PRICE_FILTER_MESSAGES.nightlyExclTaxAndFees
      } else {
        if (hasMultipleRooms) {
          return PRICE_FILTER_MESSAGES.nightlyMultipleRoomsWithTaxesExclAndFeesIncl
        }
        return PRICE_FILTER_MESSAGES.nightlyWithTaxesExclAndFeesIncl
      }
    }
  }

  const getTotalPriceFilter = useCallback(
    (price: number | undefined): number | undefined => {
      if (!price) return undefined

      if (showTotalPrices && lengthOfStay) return Number(price) * lengthOfStay
      return price
    },
    [lengthOfStay, showTotalPrices]
  )

  const getNightlyPriceFilter = useCallback(
    (price: number | undefined) => {
      if (!price) return undefined
      if (showTotalPrices && lengthOfStay)
        return Math.round(Number(price) / lengthOfStay)
      return price
    },
    [lengthOfStay, showTotalPrices]
  )

  return {
    hasMultipleRooms,
    title: showTotalPrices
      ? PRICE_FILTER_MESSAGES.totalPrice
      : PRICE_FILTER_MESSAGES.nightlyPrice,
    subtitle: getSubtitleMessage(),
    getTotalPriceFilter,
    getNightlyPriceFilter
  }
}
